import angular from 'angular';
import phoneNumber from './phoneNumber';

export default angular
  .module('components.phoneNumber', [])
  .component('phoneNumber', phoneNumber).name;
